<script>
import appConfig from "@/app.config";
import LayoutMail from "@/router/layouts/LayoutMail";
import {hopThuModel} from "@/models/hopThuModel";
import Treeselect from "@riophae/vue-treeselect";
import vue2Dropzone from "vue2-dropzone";
import {required} from "vuelidate/lib/validators";
import {notifyModel} from "@/models/notifyModel";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Soạn thư",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    LayoutMail,
    Treeselect,
    vueDropzone: vue2Dropzone,
    'ckeditor-nuxt': () => {
      return import('@blowstack/ckeditor-nuxt')
    },
    Switches,
    Multiselect
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      url: process.env.VUE_APP_API_URL + 'files/view/',
      model: hopThuModel.baseJson(),
      optionsUserTree: [],
      valueConsistsOf: 'LEAF_PRIORITY',
      submitted: false,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'fontfamily', 'fontsize', '|',
            'bold', 'italic', 'underline', '|',
            'alignment', '|',
            'uploadImage',
            'link', '|',
            'undo', 'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "files/upload-ckeditor",
          headers: {
            'Authorization': 'optional_token'
          }
        },
        placeholder: 'Nội dung'
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 15,
        maxFilesize: 50,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".jpeg, .jpg, .png, .gif, .doc, .docx,.xls, .xlsx,.pptx,.pdf, .zip, .rar, .ppt",
        dropzoneClassName: "dropzonevue-box"
      },
      isLoading: false,
      checkAll: false,
      showNguoiNhan: false,
      field: [
        {
          key: 'STT',
          label: 'STT',
          sortable: false,
          class: "text-center text-thuden",
          thClass: 'hidden-sortable text-center',
          thStyle: {width: '50px', minWidth: '50px'},
        },
        {
          key: "hoTen",
          label: "Họ tên",
          class: 'text-thuden',
          sortable: true,
          thStyle: "text-align:left",
          thClass: 'hidden-sortable',
        },
        {
          key: "chucVu",
          label: "Chức vụ",
          class: 'text-thuden text-center cs-show-col',
          thStyle: {width: '150px', minWidth: '150px'},
          sortable: true,
          thClass: 'hidden-sortable text-center',
        },
        {
          key: "donVi",
          label: "Đơn vị",
          class: 'text-thuden text-center cs-show-col',
          thStyle: {minWidth: '200px'},
          sortable: true,
          thClass: 'hidden-sortable text-center',
        },
        {
          key: 'process',
          label: '',
          class: 'text-thuden',
          thStyle: {width: '50px', minWidth: '50px'},
          thClass: 'hidden-sortable',
          sortable: false
        }
      ],
      userOption: {
        totalRows: 1,
        currentPage: 1,
        numberOfElement: 0,
        perPage: 10,
        pageOptions: [10, 100],
        filter: null,
        isBusy: false,
        id: null,
        read: false
      },
      donVis: [],
      itemFilter: {
        content: null,
        donVi: null
      },
      itemFilterCC: {
        content: null,
        donVi: null
      },
      users: [],
      showCC: false
    };
  },
  validations: {
    model: {
      title: {required},
      nguoiNhans: {required},
    },
  },
  computed: {},
  async created() {
    await this.getUserTree();
  },
  mounted() {

  },
  methods: {
    handleDeleteCC(id) {
      this.model.cc = this.model.cc.filter(x => x.id != id)
      this.users = this.users.filter(x => x.id != id)
    },
    handleDeleteUser(id) {
      this.model.nguoiNhans = this.model.nguoiNhans.filter(x => x.id != id)
      this.users = this.users.filter(x => x.id != id)
    },
    handleModalCC(value = false) {
      this.users = []
      this.showCC = value;
      if (this.model.cc) {
        this.userOption.totalRows = this.model.cc.length;
        this.userOption.isBusy = false;
        this.users = [...this.model.cc]
      } else {
        this.userOption.totalRows = 0;
        this.userOption.isBusy = false;
      }
      this.itemFilterCC.donVi = null;
      this.itemFilterCC.content = null;
    },
    handleModalNguoiNhan(value = false) {
      this.users = []
      this.showNguoiNhan = value;
      if (this.model.nguoiNhans) {
        this.userOption.totalRows = this.model.nguoiNhans.length;
        this.userOption.isBusy = false;
        this.users = [...this.model.nguoiNhans]
      } else {
        this.userOption.totalRows = 0;
        this.userOption.isBusy = false;
      }
      this.itemFilter.donVi = null;
      this.itemFilter.content = null;
    },
    getNguoiGuiByUserName(userName) {
      let user = null;
      this.optionsUserTree.forEach(function (item, index) {
        item.children.forEach(function (value, index) {
          if (value.userName == userName) {
            user = value;
            return value;
          }
        });
      });
      return user;
    },
    async getActionMail() {
      let id = this.$route.params.id;
      let type = this.$route.name;
      if (id) {
        await this.handleShowChiTietModal(id)
        let title = this.model.title.trim();
        if (type == "tra-loi") {
          this.model.nguoiNhans = [];
          this.model.cc = [];
          let findFirst = title.substring(0, 3);
          if (findFirst.toLowerCase() != "re:")
            this.model.title = "Re: " + this.model.title;
          let user = this.getNguoiGuiByUserName(this.model.user.userName);
          if (user) this.model.nguoiNhans.push(user);
          this.model.files = [];
          this.model.content = "";
        }
        if (type == "chuyen-tiep") {
          this.model.nguoiNhans = [];
          this.model.cc = [];
          let findFirst = title.substring(0, 3);
          if (findFirst.toLowerCase() != "fw:")
            this.model.title = "Fw: " + this.model.title;
        }
        if(type == "tra-loi-tat-ca"){
          let data = await this.getUserReply(this.model.mailId);
          this.model.nguoiNhans = [];
          this.model.cc = [];
          let findFirst = title.substring(0, 3);
          if (findFirst.toLowerCase() != "re:")
            this.model.title = "Re: " + this.model.title;
          if(data.nguoiNhan){
            data.nguoiNhan.map((value) =>{
              let user = this.getNguoiGuiByUserName(value);
              if (user) this.model.nguoiNhans.push(user);
            })
          }
          if(data.cc){
            data.cc.map((value) =>{
              let user = this.getNguoiGuiByUserName(value);
              if (user) this.model.cc.push(user);
            })
          }
          this.model.files = [];
          this.model.content = "";
        }
      } else {
        this.model = hopThuModel.baseJson()
      }
    },
    async handleShowChiTietModal(id) {
      await this.$store.dispatch("mailStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = res.data;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async getUserReply(id) {
      let result =await this.$store.dispatch("mailStore/getUserReply", id).then((res) => {
       return res.data
      });
      return result;
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.model.uploadFiles.filter(x => {
          return x.fileId != idFile;
        })
        this.model.uploadFiles = resultData;
      }
    },
    addThisFile(file, response) {
      if (this.model) {
        if (this.model.uploadFiles == null || this.model.uploadFiles.length <= 0) {
          this.model.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.model.uploadFiles.push({
          fileId: fileSuccess.id,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext,
          size: fileSuccess.size
        })
      }
    },
    normalizer(node) {
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
    },
    async getUserTree() {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      })
      try {
        await this.$store.dispatch("userStore/userTreeForDonVi").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUserTree = items;
            this.isLoading = true;
            this.optionsUserTree.map((value) => {
              this.donVis.push({id: value.id, ten: value.label});
            })
            loader.hide()
          }
          return [];
        });
      } finally {
        this.loading = false;
        loader.hide()
      }
    },
    async handleSubmit(e, text) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          // Update model
          await this.$store.dispatch("hopThuStore/createSend", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.$router.push('/thu-da-gui')
              this.$store.dispatch("snackBarStore/addNotify", {resultCode: "SUCCESS", resultString: text})
            } else {
              this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
            }

          });
        } else {
          // Create model
          await this.$store.dispatch("mailStore/createSend", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.$router.push('/thu-da-gui')
              this.$store.dispatch("snackBarStore/addNotify", {resultCode: "SUCCESS", resultString: text})
            } else {
              this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
            }

          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    handleDeleteFilePhuLuc(index) {
      if (this.model) {
        if (this.model.files) {
          this.model.files.splice(index, 1);
        }
      }
    },

  },
  watch: {
    isLoading(value) {
      if (value) {
        this.getActionMail();
      }
    },
    checkAll(value) {
      if (value) {
        this.model.nguoiNhans = [];
        this.optionsUserTree.map((item) => {
          if (item) {
            if(item.isLevel){
              item.children.map((value) =>{
                if(value.status == 1){
                  this.model.nguoiNhans.push(value);
                } else if(value.status == 2){
                  this.model.nguoiNhans.push(...value.children)
                }
              })
            }
            else {
              this.model.nguoiNhans.push(...item.children)
            }
          }
        })
      } else {
        this.model.nguoiNhans = []
      }
    },
    users: {
      deep: true,
      async handler(value) {
        console.log(value)
        if (value) {
          this.userOption.totalRows = value.length;
        } else {
          this.userOption.totalRows = 0;
        }
      }
    },
    itemFilter: {
      deep: true,
      async handler(val) {
        let content = val.content;
        if (content && content != "" && val.donVi) {
          this.users = this.model.nguoiNhans.filter(x => (x.userName.toLowerCase().includes(content.toLowerCase()) || x.fullName.toLowerCase().includes(content.toLowerCase())) && x.donVi.id == val.donVi.id);
        } else {
          if ((content == null || (content != null && content == "")) && val.donVi == null) {
            this.users = this.model.nguoiNhans;
          } else {
            if (val.donVi) {
              this.users = this.model.nguoiNhans.filter(x => x.donVi.id == val.donVi.id);
            }
            if (content != null && content != "") {
              this.users = this.model.nguoiNhans.filter(x => x.userName.toLowerCase().includes(content.toLowerCase()) || x.fullName.toLowerCase().includes(content.toLowerCase()));
            }
          }
        }

        this.userOption.totalRows = this.users.length;
      }
    },
    itemFilterCC: {
      deep: true,
      async handler(val) {
        let content = val.content;
        if (content && content != "" && val.donVi) {
          this.users = this.model.cc.filter(x => (x.userName.toLowerCase().includes(content.toLowerCase()) || x.fullName.toLowerCase().includes(content.toLowerCase())) && x.donVi.id == val.donVi.id);

        } else {
          if ((content == null || (content != null && val.content == "")) && val.donVi == null) {
            this.users = this.model.cc;
          } else {
            if (val.donVi) {
              this.users = this.model.cc.filter(x => x.donVi.id == val.donVi.id);
            }
            if (content != null && content != "") {
              this.users = this.model.cc.filter(x => x.userName.toLowerCase().includes(content.toLowerCase()) || x.fullName.toLowerCase().includes(content.toLowerCase()));
            }
          }
        }

        this.userOption.totalRows = this.users.length;
      }
    },
  },
};
</script>

<template>
  <LayoutMail>
    <div class="card p-3" ref="maildetail">
      <div class="btn-toolbar d-flex justify-content-between p-0 py-2">
        <div class="d-flex align-items-center gap-3">
          <b-button class="px-3" variant="light" @click="handleSubmit" title="Trở lại">
            <i class="fab fa-telegram-plane text-primary"></i>
            <span class="d-none d-md-inline-block ms-1"> Gửi thư</span>
          </b-button>
          <div class="d-flex align-items-center">
            <switches v-model="checkAll" color="primary" class="ml-1 mx-2">Chọn tất cả</switches>
            <span for="" class="text-dark">Chọn tất cả</span>
          </div>

        </div>

        <div class="">
          <b-button-group size="sm">
            <b-button class="me-1" variant="primary" title="Người nhận" @click="handleModalNguoiNhan(true)">
              <i class="fas fa-user-friends text-white"></i>
              <span class="d-none d-md-inline-block ms-1">Người nhận</span>
            </b-button>
            <b-button class="me-1" variant="success" title="CC" @click="handleModalCC(true)">
              <i class="fas fa-user-friends text-white"></i>
              <span class="d-none d-md-inline-block ms-1">CC</span>
            </b-button>
          </b-button-group>
        </div>
      </div>
      <form ref="formContainer">

        <div class="email-box">
          <div class="mb-2">
            <treeselect
                v-model="model.nguoiNhans"
                :multiple="true"
                :options="optionsUserTree"
                :searchable="true"
                :value-consists-of="valueConsistsOf"
                :normalizer="normalizer"
                :clearOnSelect="true"
                value-format="object"
                placeholder="Người nhận"
                :limit="5"
                class="cs-treeselect"
                :class="{
                                'is-invalid':
                                  submitted && $v.model.nguoiNhans.$error,
                                }"
            >

              <label slot="option-label"
                     slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                     :class="labelClassName">
                {{ node.label }}
                <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
              </label>
            </treeselect>
            <div
                v-if="submitted && !$v.model.nguoiNhans.required"
                class="invalid-feedback"
            >
              Người nhận không được để trống.
            </div>
          </div>
          <div class="mb-2">
            <treeselect
                v-model="model.cc"
                :multiple="true"
                :options="optionsUserTree"
                class="cs-treeselect"
                placeholder="Cc"
                :searchable="true"
                :clearOnSelect="true"
                :value-consists-of="valueConsistsOf"
                :normalizer="normalizer"
                value-format="object"
                :limit="5"
            >

              <label slot="option-label"
                     slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                     :class="labelClassName">
                {{ node.label }}
                <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
              </label>
            </treeselect>
          </div>
          <div class="mb-2">
            <b-form-input
                id="example-text-input"
                v-model="model.title"
                placeholder="Tiêu đề"
                class="cs-input-border"
                :class="{'is-invalid': submitted && $v.model.title.$error,}"
            ></b-form-input>
            <div
                v-if="submitted && !$v.model.title.required"
                class="invalid-feedback"
            >
              Tiêu đề thư không được để trống.
            </div>
          </div>
          <div class="mb-2">
            <!--            <ckeditor-->
            <!--                v-model="model.noiDung"-->
            <!--                :editor="editor"-->
            <!--                :config="editorConfig"-->
            <!--            ></ckeditor>-->
            <div class="mb-2">
              <ckeditor-nuxt v-model="model.content" :config="editorConfig"/>
              <!--                                                <ckeditor-->
              <!--                                                    v-model="model.content"-->
              <!--                                                    :editor="editor"-->
              <!--                                                    :config="editorConfig"-->
              <!--                                                    :class="{'is-invalid': submitted && $v.model.content.$error,}"-->
              <!--                                                ></ckeditor>-->
            </div>
          </div>
          <div v-if="model.files && model.files.length > 0" class="col-md-12">
            <label for="">Danh sách tệp tin (Nhấn vào để tải xuống)</label>
            <template>
              <div v-for="(file, index) in model.files" :key="index">
                <a
                    v-if="file.ext == '.pdf'"
                    :href="`/xem-tep-tin/${file.fileId}`"
                    class=" fw-medium"
                    target="_blank"
                ><i
                    :class="`mdi font-size-16 align-middle me-2`"
                ></i>
                  {{ index + 1 }}: {{ file.fileName }}</a
                >
                <a
                    v-else
                    :href="`${apiUrl}files/view/${file.fileId}`"
                    class=" fw-medium"
                    target="_blank"
                ><i
                    :class="`mdi font-size-16 align-middle me-2`"
                ></i>
                  {{ index + 1 }}: {{ file.fileName }}</a
                >
                <button
                    type="button"
                    size="sm"
                    class="btn btn-outline btn-sm"
                    data-toggle="tooltip" data-placement="bottom" title="Xóa"
                    v-on:click="handleDeleteFilePhuLuc(index)">
                  <i class="fas fa-trash-alt text-danger me-1"></i>
                </button>
              </div>
            </template>
          </div>
          <div class="mb-2">
            <vue-dropzone
                id="dropzone"
                ref="myVueDropzone"
                :use-custom-slot="true"
                :options="dropzoneOptions"
                class="dropzonevue-box-soanthu"
                v-on:vdropzone-removed-file="removeThisFile"
                v-on:vdropzone-success="addThisFile"
            >
              <div class="dropzone-custom-content-soanthu">
                <i
                    class="display-1 text-warning fas fa-cloud-upload-alt fs-3"
                    style="font-size: 70px"
                ></i>
                <p style="font-weight: bold; font-size: 16px">
                  Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                </p>
              </div>
            </vue-dropzone>
          </div>
        </div>
      </form>
    </div>
    <!--        Modal Người nhận -->
    <b-modal
        v-model="showNguoiNhan"
        centered
        title="Danh sách người nhận"
        title-class="fw-bold fs-5 text-dark"
        no-close-on-backdrop
        size="xl"
    >
      <div>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
              <!-- Nội dung -->
              <div class="flex-grow-1 me-2">
                <label>Từ khoá</label>
                <input
                    size="sm"
                    type="text"
                    name="untyped-input"
                    class="form-control"
                    v-model="itemFilter.content"
                    placeholder=""
                />
              </div>
              <!-- Đơn vị soạn-->
              <div class="flex-grow-1 me-2">
                <label>Đơn vị</label>
                <multiselect
                    v-model="itemFilter.donVi"
                    :options="donVis"
                    track-by="id"
                    label="ten"
                    placeholder="Chọn đơn vị soạn"
                    deselect-label="Nhấn để xoá"
                    selectLabel="Nhấn enter để chọn"
                    selectedLabel="Đã chọn"
                ></multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive-lg">
          <b-table striped hover :items="users" :fields="field"
                   class="datatables"
                   bordered
                   responsive="sm"
                   :per-page="userOption.perPage"
                   :current-page="userOption.currentPage"
                   :sort-by.sync="userOption.sortBy"
                   :sort-desc.sync="userOption.sortDesc"
                   ref="tblList1"
                   primary-key="id"
                   :busy.sync="userOption.isBusy"
          >
            <template v-slot:cell(STT)="data">
              {{ data.index + ((userOption.currentPage - 1) * userOption.perPage) + 1 }}
            </template>
            <template v-slot:cell(hoTen)="data">
              {{ data.item.fullName }} <br/>
              {{ data.item.userName }}
            </template>
            <template v-slot:cell(chucVu)="data">
              {{ data.item.chucVu.ten }}
            </template>
            <template v-slot:cell(donVi)="data">
              {{ data.item.donVi.ten }}
            </template>
            <template v-slot:cell(process)="data">
              <div class="d-flex justify-content-center">
                <button
                    type="button"
                    size="sm"
                    class="btn btn-delete btn-sm"
                    data-toggle="tooltip" data-placement="bottom" title="Xóa"
                    @click="handleDeleteUser(data.item.id)"
                >
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
            </template>
          </b-table>
          <template v-if="userOption.isBusy">
            <div align="center">Đang tải dữ liệu</div>
          </template>

          <template v-if="userOption.totalRows <= 0 && !userOption.isBusy">
            <div align="center">Không có dữ liệu</div>
          </template>
        </div>
        <div>
          <div class="row mb-2">
            <div class="col-sm-12 col-md-6">
              <div style="display: flex; justify-content: start; align-items: center">
                <div style="margin-right: 20px" class="">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Hiện
                      <b-form-select
                          class="form-select form-select-sm"
                          v-model="userOption.perPage"
                          size="sm"
                          :options="userOption.pageOptions"
                      ></b-form-select
                      >&nbsp;dòng
                    </label>
                  </div>

                </div>
                <div class="">
                  <div>Hiển thị {{ userOption.numberOfElement }} trên tổng số {{ userOption.totalRows }} dòng</div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div
                  class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                      v-model="userOption.currentPage"
                      :total-rows="userOption.totalRows"
                      :per-page="userOption.perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      <template #modal-footer>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  class="btn btn-outline-info w-md"
                  v-on:click="handleModalNguoiNhan()">
          Đóng
        </b-button>
      </template>
    </b-modal>
    <!--        Modal CC -->
    <b-modal
        v-model="showCC"
        centered
        title="Danh sách CC"
        title-class="fw-bold fs-5 text-dark"
        no-close-on-backdrop
        size="xl"
    >
      <div>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
              <!-- Nội dung -->
              <div class="flex-grow-1 me-2">
                <label>Từ khoá</label>
                <input
                    size="sm"
                    type="text"
                    name="untyped-input"
                    class="form-control"
                    v-model="itemFilterCC.content"
                    placeholder=""
                />
              </div>
              <!-- Đơn vị soạn-->
              <div class="flex-grow-1 me-2">
                <label>Đơn vị</label>
                <multiselect
                    v-model="itemFilterCC.donVi"
                    :options="donVis"
                    track-by="id"
                    label="ten"
                    bảneholder="Chọn đơn vị soạn"
                    deselect-label="Nhấn để xoá"
                    selectLabel="Nhấn enter để chọn"
                    selectedLabel="Đã chọn"
                ></multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive-lg">
          <b-table striped hover :items="users" :fields="field"
                   class="datatables"
                   bordered
                   responsive="lg"
                   :per-page="userOption.perPage"
                   :current-page="userOption.currentPage"
                   :sort-by.sync="userOption.sortBy"
                   :sort-desc.sync="userOption.sortDesc"
                   ref="tblList1"
                   primary-key="id"
                   :busy.sync="userOption.isBusy"
          >
            <template v-slot:cell(STT)="data">
              {{ data.index + ((userOption.currentPage - 1) * userOption.perPage) + 1 }}
            </template>
            <template v-slot:cell(hoTen)="data">
              {{ data.item.fullName }} <br/>
              {{ data.item.userName }}
            </template>
            <template v-slot:cell(chucVu)="data">
              {{ data.item.chucVu.ten }}
            </template>
            <template v-slot:cell(donVi)="data">
              {{ data.item.donVi.ten }}
            </template>
            <template v-slot:cell(process)="data">
              <div class="d-flex justify-content-center">
                <button
                    type="button"
                    size="sm"
                    class="btn btn-delete btn-sm"
                    data-toggle="tooltip" data-placement="bottom" title="Xóa"
                    @click="handleDeleteCC(data.item.id)"
                >
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
            </template>
          </b-table>
          <template v-if="userOption.isBusy">
            <div align="center">Đang tải dữ liệu</div>
          </template>

          <template v-if="userOption.totalRows <= 0 && !userOption.isBusy">
            <div align="center">Không có dữ liệu</div>
          </template>
        </div>
        <div>
          <div class="row mb-2">
            <div class="col-sm-12 col-md-6">
              <div style="display: flex; justify-content: start; align-items: center">
                <div style="margin-right: 20px" class="">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Hiện
                      <b-form-select
                          class="form-select form-select-sm"
                          v-model="userOption.perPage"
                          size="sm"
                          :options="userOption.pageOptions"
                      ></b-form-select
                      >&nbsp;dòng
                    </label>
                  </div>

                </div>
                <div class="">
                  <div>Hiển thị {{ userOption.numberOfElement }} trên tổng số {{ userOption.totalRows }} dòng</div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div
                  class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                      v-model="userOption.currentPage"
                      :total-rows="userOption.totalRows"
                      :per-page="userOption.perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      <template #modal-footer>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  class="btn btn-outline-info w-md"
                  v-on:click="handleModalCC()">
          Đóng
        </b-button>
      </template>
    </b-modal>
  </LayoutMail>
</template>

<style lang="scss">
.cs-border-tabs {
  background: #ddd;
  border: 0.5px solid #ccc;
  padding: 3px;

  & .nav-link {
    border-radius: 0px;
  }

  & .tab-content {
    background: #fff;
    margin-top: 3px;
    border: 0.5px solid #ccc;
  }
}

.cs-treeselect {
  & .vue-treeselect__control {
    border: none;
    border-bottom: 0.5px solid #d0d0d0;
    border-radius: 0px;
  }
}

.cs-input-border {
  border: none;
  border-bottom: 0.5px solid #d0d0d0;
  border-radius: 0px;
}

.cs-ckeditor {
  & .ck {
    &.ck-editor {
      display: flex;
      flex-direction: column-reverse;
    }

    &.ck-toolbar {
      background-color: #fff !important;
    }

    & .ck-editor__main {
      & .ck-content {
        border: none;
      }
    }
  }
}

.cs-modal-hopthu {
  & .modal-header {
    background-color: #f2f6fc;
    border: none !important;
  }
}
</style>
<style lang="scss" scoped>
.dropzonevue-box-soanthu {
  position: relative !important;
}

.dropzone-custom-content-soanthu {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  text-align: center !important;
}
</style>
